import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {ApiLoginRequest} from "@shared/models/interfaces/api-login.interface";
import {CoreState} from "@core/store/core.reducers";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {AuthService} from "@core/services/auth.service";

export enum ruoli {
  amministratore = 1,
  supervisore = 2,
  revisore = 3
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  showPassword = false;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<CoreState>,
    private router: Router,
    private authService: AuthService
  ) {
    this.form = this.fb.group({
      userNameOrEmailAddress: ['', Validators.required],
      password: ['', Validators.required],
      rememberClient: true
    })
  }

  submit(): void {
    if(this.form.invalid){
      return;
    }
    const body: ApiLoginRequest = this.form.value;
    this.authService.login(body)
  }

}


